<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">After qualifying in medicine from Oxford, and then becoming a Fellow of the Royal College of Surgeons, the author has enjoyed a varied and rewarding surgical career.</p><br/>
<p style="text-indent:0em;">A longstanding interest in history and in teaching medical students has made it clear that an understanding of the past and how advances in medicine and surgery have been achieved makes it easier to follow the rationale for present treatments. This learning process seems as valid for nations, politicians and despots, even individuals, as for medical students and doctors.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?f2ad31a6